<mat-card>
  <mat-card-header>
    <mat-card-title class="popupHeader">
      <div class="mat-card-header-text" i18n>
        Edit Profile
      </div>          
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <form>
      <mat-form-field  class="my-form-field">
        <mat-label i18n>First Name</mat-label>
        <input matInput [(ngModel)]="userProfile.firstName" name="fname" required>
      </mat-form-field>
      <mat-form-field  class="my-form-field">
        <mat-label i18n>Last Name</mat-label>
        <input matInput [(ngModel)]="userProfile.lastName" name="lname" required>
      </mat-form-field>
      <mat-form-field class="my-form-field" required>
        <mat-label i18n>Role</mat-label>
        <mat-select (valueChange)="selectedRole($event)" [(value)]="currentUserRole" required>
          <mat-option *ngFor="let role of roles" [value]="role">
            {{role}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="my-form-field">
        <mat-label i18n>Email</mat-label>
        <input matInput [(ngModel)]="userProfile.email" name="email" required>
      </mat-form-field>
      <mat-form-field class="my-form-field">
        <mat-label i18n>Company</mat-label>
        <input matInput [(ngModel)]="userProfile.company" name="company" required>
      </mat-form-field>
    </form>
  </mat-card-content>

  <mat-card-actions>   
    <div class="buttonContent">      
      <button mat-raised-button type="button" color="primary" (click)="createNewProfile()">{{buttonMode}}
      </button>
    </div>   
  </mat-card-actions>  
</mat-card>